import React from "react";

const ErrorMessage = ({ message }) => {
    return <div className="bg-red-500 text-white text-center">{message}</div>;
};

export default ErrorMessage;
